let headerFlag        = false;
let stHeader  = document.getElementById('st-Header');
let stHeaderNav  = document.getElementById('st-Header_Nav');
let stHeaderBg  = document.getElementById('st-Header_Bg');
let headerButton  = document.getElementById('st-Menu');

// var windowW       = $(window).width();
// var windowH       = $(window).innerHeight();
// var _isSP         = false;
// var _isipad  = false;



// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{


  history.replaceState(null, null, null);
  window.addEventListener('popstate', function() {

    $('body').addClass('preload');

    headerFlag        = false;
    stHeaderNav.classList.remove('opened');
    headerButton.classList.remove('opened');
    stHeaderBg.classList.remove('opened');
    stHeaderLogo.classList.remove('opened');
    stHeaderNav.classList.add('closed');
    headerButton.classList.add('closed');
    stHeaderBg.classList.add('closed');
    stHeaderLogo.classList.add('closed');

    setTimeout(function(){
      $('body').removeClass('preload');
    },100);

  }, false);

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};

// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {


  headerButton.addEventListener('click', () => {

    if(!headerFlag){
      // $('#st-Header_Navi').css({'display':'block'});
      setTimeout(function(){
        stHeader.classList.remove('closed');
        stHeaderNav.classList.remove('closed');
        headerButton.classList.remove('closed');
        stHeaderBg.classList.remove('closed');
        stHeader.classList.add('opened');
        stHeaderNav.classList.add('opened');
        headerButton.classList.add('opened');
        stHeaderBg.classList.add('opened');
        headerFlag = true;
  		},0);
    }else{
      stHeader.classList.remove('opened');
      stHeaderNav.classList.remove('opened');
      headerButton.classList.remove('opened');
      stHeaderBg.classList.remove('opened');
      stHeader.classList.add('closed');
      stHeaderNav.classList.add('closed');
      headerButton.classList.add('closed');
      stHeaderBg.classList.add('closed');
      headerFlag = false;
      // setTimeout(function(){
      //   // $('#st-Header_Navi').css({'display':'none'});
  		// },0);
    }
  }, false);

};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  $("#st-Top").on("click", function(){
    var linkSpeed    = 800;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutExpo");
    return false;
  });
};


// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#sw-Youtube');
  const $content = $('#sw-Youtube_Content');

  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#sw-Youtube').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},300,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;
    });

  });


  //close
  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function(){

    $('#sw-Youtube').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#sw-Youtube').css({'display':'none'});
      $content.children('iframe').remove();
		});
  });

};



// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {

  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 0;
          $('body,html').stop().animate({scrollTop:position}, 500);
      }, 200);
  }

  var linkSpeed    = 700;
  var linkAdjust   = 10;

  //ページ内リンク
  $("a[href^='#']").on("click", function(){

    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkPosition = linkTarget.offset().top;

    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "easeInOutQuint");
    return false;
  });

};




export {
  preload,
  toggleHeader,
  pageTop,
  showMovie,
  anchorLink
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js